import api, { apiSetup } from '../api';

apiSetup(undefined);

export class SectorsService {
  BASE_URL = '/sectors/';

  get() {
    return api.get<any>(this.BASE_URL);
  }
}
